import { genetecIntegration } from "../genetec";
import { Integration } from "./Integration";

export const integrations: Integration[] = [genetecIntegration];
